module.exports = __webpack_public_path__ + "static/coveruxcoronavirus-39fadf14f002dbf5cbd69cf456c2260a.png";